
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_g8no8_ju9sr_5",
  "action-button": "awsui_action-button_g8no8_ju9sr_9",
  "inline-label": "awsui_inline-label_g8no8_ju9sr_13"
};
  